import type { ReactNode } from 'react';
import { cn } from '../cn.js';

export interface StatTileProps {
  label: string;
  value: ReactNode;
  /** Optional sub-line, e.g. "of 128 conversations". */
  sub?: ReactNode;
  className?: string;
}

/** A single headline metric. Value in primary ink, label/sub muted. */
export function StatTile({ label, value, sub, className }: StatTileProps) {
  return (
    <div
      className={cn(
        'rounded-2xl border border-brand-sage/15 bg-card p-5 text-card-foreground shadow-brand',
        className,
      )}
    >
      <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</p>
      <p className="mt-2 text-2xl font-semibold tracking-tight">{value}</p>
      {sub ? <p className="mt-1 text-xs text-muted-foreground">{sub}</p> : null}
    </div>
  );
}
